import React, { useState, useEffect } from 'react';
import { FormControl, FormLabel, FormControlLabel, Checkbox, FormGroup, FormHelperText, Grid } from '@mui/material';
import { newFoodTypes as newFoodTypesModel } from '../../../../../models/foodTypes';

const FooTypeListItem = ({ foodTypes, foodType, disabled, handleCheck }) => (
  <FormGroup>
    <FormControlLabel
      key={foodType.name}
      label={foodType.label}
      data-testid={foodType.label}
      control={
        <Checkbox
          disabled={disabled}
          name={foodType.name}
          color="secondary"
          // checkedIcon={foodType.name === 'eggs' || foodType.name === 'non-food' ? <CheckBoxIcon /> : <IndeterminateCheckBoxIcon />}
          checked={(foodTypes || []).includes(foodType.name)}
          value={foodType.name}
          onChange={handleCheck}
        />
      }
    />
  </FormGroup>
);

const FoodTypes = ({
  errors = {},
  label = 'Rescue Contents',
  forceColumns = false,
  foodTypeOther,
  disabled,
  foodTypes,
  onFoodTypeChange,
  onFoodTypeOtherChange,
  onSubCategoryChange,
}) => {
  const [foodTypeOtherValue, setFoodTypeOtherValue] = useState(foodTypeOther);

  useEffect(() => {
    setFoodTypeOtherValue(foodTypeOther); //update value on redux change
  }, [foodTypeOther]);

  const handleCheck = event =>
    onFoodTypeChange({
      foodType: event.target.name,
      checked: event.target.checked,
    });

  const handleSubCheck = event => 
    onSubCategoryChange({
      category: event.target.name,
      checked: event.target.checked,
    });

  return (
    <FormControl
      variant="standard"
      error={errors.hasOwnProperty('food_types') || errors.hasOwnProperty('food_type_other')}
      data-testid="food_types"
    >
      <FormLabel component="legend" id="legend-food_types">
        {label}
      </FormLabel>
      <Grid container spacing={1}>
        {/*  Render array in two seperate columns */}
        <Grid item xs={forceColumns ? 6 : 12} sm={6}>
          {newFoodTypesModel.slice(0, Math.ceil(newFoodTypesModel.length / 2)).map((foodType) => (
            <FooTypeListItem
              key={foodType.name}
              foodTypes={foodTypes}
              foodType={foodType}
              disabled={disabled}
              handleCheck={handleCheck}
            />
          ))}
        </Grid>
        <Grid item xs={forceColumns ? 6 : 12} sm={6}>
          {newFoodTypesModel.slice(Math.ceil(newFoodTypesModel.length / 2)).map((foodType) => (
            <FooTypeListItem
              key={foodType.name}
              foodTypes={foodTypes}
              foodType={foodType}
              disabled={disabled}
              handleCheck={handleCheck}
            />
          ))}
        </Grid>
      </Grid>

      {errors.hasOwnProperty('food_types') && (
        <FormHelperText error id="food_types-error">
          {errors.food_types.message}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default FoodTypes;
